import {config} from './axios';

export const ApiConfig = {
    timeZone: 'America/New_York',
    encryptKey : 'Tw5qNOJLe5GFe7rjFsentNNQBsRHstbNzTP/18lkjnY=',
   paymantHistory: config.baseURL  + '/partner-payment-history',
   partnerInvoice: config.baseURL  + '/partner-invoice',
}